// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-q_gh","galleryThumbnail_active":"c-q_gi","galleryThumbnail__image":"c-q_gj"};